<div class= "page page--partner-analytics">
  <div class="page__container">
    <h1 class="page__title  h2" translate>partner_analytics_title</h1>
    <div class="my-5">
    <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
      <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>partner_analytics_campaigns_title</button>
      <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
        <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
          partner_analytics_campaigns_title
        </button>
        <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
          partner_analytics_customers_title
        </button>
        <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">partner_analytics_activities_title</button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device custom" [(activeId)]="activeId">
      <li [ngbNavItem]="1">
        <a ngbNavLink translate>partner_analytics_campaigns_title</a>
        <ng-template ngbNavContent>
          <wsb-partner-report-campaigns></wsb-partner-report-campaigns>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink translate>partner_analytics_customers_title</a>
        <ng-template ngbNavContent>
          <wsb-partner-list-referrals></wsb-partner-list-referrals>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink translate>partner_analytics_activities_title</a>
        <ng-template ngbNavContent>
          <wsb-partner-report-referrals></wsb-partner-report-referrals>
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
</div>

